<div class="pad-L primary">
	<div class="flex-align-center gap-S f-d-r mb-m">
		<app-chips [square]="true" [size]="'xl'">
			<img src="assets/icons/grid.svg" class="filter-grey" height="25px">
		</app-chips>
		<div class="flex-column gap-XS ml-s">
			<div class="font-L fw-700">{{ 'page.settings.agent.inventory' | translate }}</div>
			<div class="font-M fw-300">{{ 'page.settings.agent.inventorySubtitle' | translate }}</div>
		</div>
	</div>
	<div class="flex flex-align-center gap-S mb-m">
		<app-text-input class="w-100" [disabled]="!initialized" [placeholder]="'page.settings.agent.search' | translate" [input]="searchInput"></app-text-input>
		<div style="padding: 3px;" class="flex-align-center filter-bar bkg-white b-radius-6">
			<app-text-button style="width: 35px; height: 35px;" type="default" color="primary"
							 panelClass="h-100-imp pad-0-imp"
							 [matMenuTriggerFor]="menu"
							 #menuTriggerRef="matMenuTrigger"
							 [disabled]="_loading"
							 [loading]="_loading">
				<div class="flex-center">
					<img src="assets/icons/dots-vertical.svg" height="18" alt=""/>
				</div>
			</app-text-button>
			<mat-menu #menu class="mat-menu-dots"
					  xPosition="before" yPosition="below">
				<div style="padding: 6px;">
					<div (click)="selectAll(); $event.stopPropagation();" class="flex-align-center gap-S b-radius-6 c-p multi-select-button" style="padding: 5px 10px; width: 200px">
						<img src="assets/icons/check-done-02.svg" width="18" class="filter-white" height="18" alt=""/>
						<div class="font-M fw-500 white">{{ 'global.multiSelect.selectAll' | translate }}</div>
					</div>
					<div (click)="deselectAll(); $event.stopPropagation();" class="flex-align-center gap-S b-radius-6 c-p multi-select-button" style="padding: 5px 10px; width: 200px;">
						<img src="assets/icons/check-done-03.svg" width="18" class="filter-white" height="18" alt=""/>
						<div class="font-M fw-500 white">{{ 'global.multiSelect.selectNone' | translate }}</div>
					</div>
				</div>
			</mat-menu>
		</div>
	</div>
	<div class="bg-rounded-2 custom-scrollbar" style="max-height: calc(80vh - 300px); min-height: calc(80vh - 300px); overflow-x: hidden;">
		<div *ngIf="initialized">
			<div *ngFor="let application of filteredApplications; let i = index">
				<div class="pad-L flex-justify-center flex-column">
					<div class="flex-space-between">
						<div class="disp-f a-i-c gap-S overflow-hidden">
							<app-display-logo [logo]="application.logo" [size]="30"></app-display-logo>
							<span class="font-M text-overflow-ellipsis">{{ application.name }}</span>
						</div>
						<mat-checkbox class="custom-checkbox"
									  [checked]="application.displayedInExtension"
									  (change)="onCheckChange(application, $event)"></mat-checkbox>
					</div>
				</div>
				<hr *ngIf="i < filteredApplications.length - 1" />
			</div>
			<div *ngIf="filteredApplications.length <= 0 && applications.length > 0" class="flex-center flex-column gap-M" style="height: calc(80vh - 300px);">
				<img src="assets/illustrations/empty-capacity.svg">
				<span class="grey">{{ 'page.settings.agent.noAppSearch' | translate }}</span>
			</div>
			<div *ngIf="applications.length <= 0" class="flex-center flex-column gap-M" style="height: calc(80vh - 300px);">
				<img src="assets/illustrations/empty-capacity.svg">
				<span class="grey">{{ 'page.settings.agent.noApp' | translate }}</span>
			</div>
		</div>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
	<div class="w-100 disp-f f-d-r j-c-sb a-i-c mt-l gap-M">
		<app-text-button class="w-50" type="stroked" (click)="onDismiss()">{{ 'button.cancel' | translate }}</app-text-button>
		<app-text-button  class="w-50" type="flat" [loading]="_loading || !initialized" (click)="updateApplicationsDisplayed()">{{ 'button.save' | translate }}</app-text-button>
	</div>
</div>
